import { Box } from "atoms";
import React from "react";
import { useLocation } from "react-router-dom";
import Amenities from "./Amenities";
import Developers from "./Developers";
import Infrastructures from "./Infrastructures";
import Location from "./Location";
import Micromarket from "./Micromarket";
import NearByAreas from "./NearByAreas";
import NearByInfrastrucures from "./NearByInfrastrucures";
import NearByTransportation from "./NearByTransportation";
import PropertyStatus from "./PropertyStatus";
import PropertyTypes from "./PropertyTypes";
import Specification from "./Specification";
import Transportations from "./Transportations";
import Typologies from "./Typologies";

export const Master = () => {
  const location = useLocation();

  return (
    <Box>
      {/* <Breadcrum
        firstText="master"
        secondText={location.pathname.replace("/master/", "").replace("-", " ")}
      /> */}

      <Box>{location.pathname === "/master/location" && <Location />}</Box>
      <Box>{location.pathname === "/master/amenities" && <Amenities />}</Box>
      <Box>
        {location.pathname === "/master/micromarket" && <Micromarket />}
      </Box>
      <Box>{location.pathname === "/master/developers" && <Developers />}</Box>
      <Box>
        {location.pathname === "/master/property-status" && <PropertyStatus />}
      </Box>
      <Box>
        {location.pathname === "/master/property-types" && <PropertyTypes />}
      </Box>
      <Box>{location.pathname === "/master/typology" && <Typologies />}</Box>
      <Box>
        {location.pathname === "/master/nearby-areas" && <NearByAreas />}
      </Box>
      <Box>
        {location.pathname === "/master/nearby-infrastructures" && (
          <NearByInfrastrucures />
        )}
      </Box>
      <Box>
        {location.pathname === "/master/nearby-transporation" && (
          <NearByTransportation />
        )}
      </Box>
      <Box>
        {location.pathname === "/master/specifications" && <Specification />}
      </Box>
      <Box>
        {location.pathname === "/master/infrastructures" && <Infrastructures />}
      </Box>
      <Box>
        {location.pathname === "/master/transporation" && <Transportations />}
      </Box>
    </Box>
  );
};
